import { useState } from "react";
import { Button as BootstrapButton, Col, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap"
import classes from "./DetailsCollapse.module.scss";
import Button from "../../UI/Button";
import { useTranslation } from "react-i18next";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const DetailsCollapse = ({detail, detail2, index, forms, opened, children, onAddClick}) => {
    const {t} = useTranslation();
    const [isOpened, setIsOpened] = useState(opened);
    const onAdd = (e) =>{
        e.preventDefault();
        if(onAddClick)
            onAddClick(detail,detail2, index)
    }
    return(
        <Container style={{display:"block"}}>
            <Row className={classes["detailRow"]}>
                <Col className={`align-middle ${classes["headerDetail"]} p-1`} onClick={()=> setIsOpened((e) => !e)}>
                    {/* <i className={isOpened ? "ti-arrow-circle-down" : "ti-arrow-circle-right"}></i> */}
                    {isOpened ? <KeyboardArrowDownIcon className={classes["arrow-icon"]}/> : <KeyboardArrowRightIcon className={classes["arrow-icon"]}/>}
                    <span className={classes["detailText"]}>{detail2 || detail} {`[${forms.length}]`}</span>
                </Col>
                <Col className="align-items-center d-flex" md="auto">
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("Add new. After adding, scroll down in the form to locate it and fill in the required details.")}</Tooltip>}>
                        <Button className={classes["circle-btn"]} onClick={onAdd}>+</Button>
                    </OverlayTrigger>
                    {/* <BootstrapButton onClick={onAdd} variant="info" size="sm" style={{backgroundColor:"rgb(33, 150, 243)", color:"white", margin:"3px 0px 2px 0px"}}>
                        Add
                    </BootstrapButton> */}
                </Col>
            </Row>
            <Row className={classes["details"]}>
                {isOpened && children}
            </Row>
        </Container>
    )
}